import { render } from "./InputQuantity.vue?vue&type=template&id=c25dc9c4"
import script from "./InputQuantity.vue?vue&type=script&lang=js"
export * from "./InputQuantity.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\mihne\\Desktop\\matrixWork\\individual\\datacenter\\printqMatrix\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__